export default "__VITE_ASSET__BjCTGLCA__"